import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.BATCHES_PROCESSING.BATCHES_MANAGEMENT_MENU;

const BatchesManagementMenuLink: Array<LinkItemProps> = [
  {
    name: 'Paramètres Batches',
    link: URL.BATCHES_PARAMETERS,
    level: 1,
  },
  {
    name: 'Dépendances Batches',
    link: URL.BATCHES_DEPENDENCIES,
    level: 1,
  },
  {
    name: 'Monitoring Batches',
    link: URL.BATCHES_MONITORING,
    level: 1,
  },
  {
    name: 'Maintenance Batches',
    link: URL.BATCHES_MAINTENANCE,
    level: 1,
  },
  {
    name: 'Erreurs Batch',
    link: URL.BATCH_ERRORS,
    level: 1,
  },
  {
    name: 'Traces Batches',
    link: URL.BATCHES_TRACKS,
    level: 1,
  },
  {
    name: 'Traitements Journaliers',
    level: 1,
    subMenu: [
      {
        name: "Mise à Jour",
        link: URL.DAILY_PROCESSING_MENU.UPDATE,
        level: 2,
      },
      {
        name: "Dépendances",
        link: URL.DAILY_PROCESSING_MENU.DEPENDENCIES,
        level: 2,
      },
      {
        name: "Supervision",
        link: URL.DAILY_PROCESSING_MENU.SUPERVISION,
        level: 2,
      },
      {
        name: "Traces",
        link: URL.DAILY_PROCESSING_MENU.TRACES,
        level: 2,
      },
      {
        name: "Erreurs",
        link: URL.DAILY_PROCESSING_MENU.ERRORS,
        level: 2,
      },
    ]
  },
  
];

export default BatchesManagementMenuLink;
